Vue.component('profileitem', {
    props: {
        fieldid: {
            type: Number,            
        },
        selectedData: {
            type: Object
        },
        profileStateData: {
            type: Object,            
        },
        tableRows: {
            type: Object
        },
        featured: {
            type: Array
        },
        districtdata: {}
    },
    computed: {
        dataField () {
            let item = this.selectedData.selected.filters.data_field_id.filter(item => item.data_field_id == this.fieldid.toString());
            if (item) {
                return item[0];
            }
            return {
                "data_name": "Loading..." 
            }            
        },
        dataName () {
            if (this.dataField) {
                return this.dataField.data_name;
            }
            return;
        },
        stateData () {
            if (this.fieldid == 20 || this.fieldid == 21) {return false;}
            return formatSlideData(this.profileStateData[this.fieldid], this.dataField.data_format);
        },
        featuredData () {
            if (this.featured && this.fieldid && this.tableRows[this.featured[0].toString()]) {
                return formatSlideData(this.tableRows[this.featured[0]]['c'+this.fieldid], this.dataField.data_format);
            }
            return '';
        },
        peerAverage () {
            let num = 0;
            let sum = 0;
            for (const i in this.tableRows) {
                if (i != this.featured[0] && this.tableRows[i]['c'+this.fieldid] != 'INF' && !isNaN(this.tableRows[i]['c'+this.fieldid])) {
                    num++;
                    sum += this.tableRows[i]['c'+this.fieldid] * 1;
                }
            }
            let avg = sum / num;
            return formatSlideData(avg, this.dataField.data_format);
        },
        peerMedian () {
            
            if (this.dataField.data_format == "Text") {return "N/A";}
            let newvals = [];                
            for (const i in this.tableRows) {
                let val = parseFloat(this.tableRows[i]['c'+this.fieldid]);
                if (i != this.featured[0] && this.tableRows[i]['c'+this.fieldid] != 'INF' && !isNaN(val)) {
                    newvals.push(val); 
                }
            }
            const mid = Math.floor(newvals.length / 2),
            nums = [...newvals].sort((a, b) => a - b);
            let r = newvals.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
            return formatSlideData(r, this.dataField.data_format)
            //return 'N/A';
            /*
            if ($this.allVals[i]) {                
                let s = 0;
                let newvals = [];
                // loop through to ignore any NaNs
                $this.allVals[i].forEach(function (v)  {
                    let val = parseFloat(v);                    
                    if (Number.isNaN(val)) {return;}
                    newvals.push(val);                    
                })
                const mid = Math.floor(newvals.length / 2),
                nums = [...newvals].sort((a, b) => a - b);
                let r = newvals.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
                return formatSlideData(r, $this.tableCols[i].data_format)
            }            
            */
        },
        stateName () {
            if (!this.profileStateData["STATE"]) {
                return "Chosen District State"
            }
            
            return this.profileStateData["STATE"].toLowerCase();
        },
        allData () {
            let d = [];            
            if (this.tableRows) {
                for (const i in this.tableRows) {
                    if (this.tableRows[i]['c'+this.fieldid] == "INF" || isNaN(this.tableRows[i]['c'+this.fieldid])) {continue;}
                    let item = {
                        district: this.districtdata[i].agency_name,
                        value: this.tableRows[i]['c'+this.fieldid]*1,   
                        featured: false,
                        StAbr: this.districtdata[i].StAbr,
                        nces_id: this.districtdata[i].nces_id                   
                    }
                    if (this.featured.includes(i)) {
                        item.featured = true;
                    }
                    d.push(item);
                }
            }            
            return d
        },
        numDistricts () {
            return Object.keys(this.tableRows).length;
        },
        showBar () {            
            if (this.numDistricts && this.numDistricts < 31) {
                return true;
            }
            return false;

        }
    }
    

});